module.exports = __webpack_public_path__ + "static/media/Audit_Trail_white.d9b4a713.png";